import { useNavigate } from "react-router";
import { Button, Input, Form, message } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import "./index.less";
import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import { loginApi } from "@/apis";
import LogoPng from "@/images/logo.png";
import { env } from "@/utils/env";

const { Search } = Input;
const validcheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,16}$/;

const logo2 = require("@/images/yd2.png");
const logo3 = require("@/images/yd3.png");
const logo4 = require("@/images/yd4.png");

const Forget = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const countRef = useRef(60);

  const [btnLoading, setBtnloading] = useState(false);
  const [count, setCount] = useState(0);
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");

  const goHome = () => {
    navigate("/home");
  };

  const handleCode = async () => {
    if (count !== 0) return;
    if (!phone) {
      message.error("手机号码不能为空");
      return;
    }
    try {
      const infoRes = await loginApi.getFindByUserNameOrPhone({
        userAccountOrPhone: phone,
      });
      if (!infoRes || infoRes.length === 0) {
        message.error("用户不存在，请检查手机号码是否有效");
        return;
      }

      const codeRes = await loginApi.fetchSendPhoneCode(phone);
      message.success("验证码已发送");
      countRef.current = 59;
      setCount(countRef.current);
      const timer = setInterval(() => {
        if (countRef.current <= 0) {
          setCount(0);
          countRef.current = 60;
          clearInterval(timer);
        } else {
          countRef.current--;
          setCount(countRef.current);
        }
      }, 1000);
    } catch (error: any) {
      message.error(error);
    }
  };

  const hanldeSubmit = async () => {
    try {
      if (step === 1) {
        if (!phone || !code) {
          message.error("手机号码和验证码不能为空");
          return;
        }
        setBtnloading(true);
        const res = await loginApi.fetchCheckCode({
          phone,
          code,
        });
        if (res) {
          setStep(2);
        } else {
          message.error("验证码错误");
        }
        setBtnloading(false);
      }
      if (step === 2) {
        form.validateFields().then((res) => {
          const { password } = res;
          loginApi
            .fetchUpdatePassword({
              phone,
              code,
              password,
            })
            .then((res) => {
              message.success("更改密码成功，请登录");
              navigate("/home?needlogin=true");
            })
            .catch((err) => {
              message.error(err);
            });
        });
      }
    } catch (error: any) {
      message.error(error);
    }
  };

  const goPreSetp = () => {
    setStep(1);
    form.resetFields();
  };

  return (
    <>
      <article className="max-width forget-wrapper">
        <article className="nav-bar flex shop-pc">
          <div className="logo flex-b-c" onClick={goHome}>
            <div className="logo-Word">
              <img src={logo3} alt="" />
              <img src={logo4} alt="" />
            </div>
            <img src={logo2} alt="" />
          </div>
          
        </article>
        <div className="top-logo shop-m">
          <img onClick={goHome} src={LogoPng} alt="" />
        </div>
      </article>
      <div style={{width: "100%", backgroundColor: "#fff"}}>
        <h3 className="forget-nav-title">忘记密码</h3>
      </div>
      
      <article className="forget-content-wrapper">
        <div className="forget-content">
          {step === 1 ? (
            <>
              <p className="tips">请填写与账号关联的手机号以接受验证信息</p>
              <Input
                value={phone}
                onChange={(e: any) => {
                  setPhone(e.target.value);
                }}
                size={env.isMobile ? "middle" : "large"}
                placeholder="请输入手机号码"
                addonBefore={
                  <MobileOutlined
                    style={{ fontSize: env.isMobile ? "16px" : "18px" }}
                  />
                }
                className="item"
                allowClear
              />
              <Search
                value={code}
                placeholder="请输入验证码"
                allowClear
                enterButton={count === 0 ? "获取验证码" : `${count}s后重新获取`}
                size={env.isMobile ? "middle" : "large"}
                onChange={(e: any) => {
                  setCode(e.target.value);
                }}
                onSearch={handleCode}
                className="item"
              />
            </>
          ) : (
            <>
              <p className="tips">请重新设置密码</p>
              <Form
                form={form}
                name="form"
                autoComplete="off"
                layout="vertical"
              >
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "密码不能为空!" },
                    {
                      required: true,
                      pattern: validcheck,
                      message: "密码必须包含大小写字母、数字、特殊字符，长度8-16位",
                    },
                  ]}
                >
                  <Input.Password
                    size={env.isMobile ? "middle" : "large"}
                    placeholder="请输入密码"
                  />
                </Form.Item>
                <Form.Item
                  name="password2"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: "请再次输入密码！",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("两次密码输入不一致!"));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size={env.isMobile ? "middle" : "large"}
                    placeholder="请再次输入密码"
                  />
                </Form.Item>
              </Form>
            </>
          )}
          <div className="btns flex-b-c">
            <Button
              loading={btnLoading}
              type="primary"
              style={{ width: env.isMobile ? "45%" : "180px" }}
              onClick={hanldeSubmit}
            >
              {step === 1 ? "下一步" : "确定"}
            </Button>
            {step === 1 ? (
              <Link
                to="/home"
                style={{
                  fontSize: env.isMobile ? "14px" : "16px",
                  color: "#707070",
                  textDecoration: "none",
                }}
              >
                返回登录
              </Link>
            ) : (
              <Button
                style={{ width: env.isMobile ? "45%" : "180px" }}
                onClick={goPreSetp}
              >
                上一步
              </Button>
            )}
          </div>
        </div>
      </article>
    </>
  );
};

export default Forget;
